import { render, staticRenderFns } from "./_base-stickyHeader.vue?vue&type=template&id=37f1166c&scoped=true&"
import script from "./_base-stickyHeader.vue?vue&type=script&lang=js&"
export * from "./_base-stickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./_base-stickyHeader.vue?vue&type=style&index=0&id=37f1166c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1166c",
  null
  
)

export default component.exports